import React from 'react';
import clsx from 'clsx';

import classes from './tag.module.scss';

export const Tag = ({ text, value, selected = false, callback = (val) => {}, className = '' }) => {
    return (
        <button
            className={clsx(
                classes.tag,
                selected && classes.selected,
                className && classes[className],
            )}
            onClick={(e) => {
                e.stopPropagation();
                callback(value);
            }}
        >
            {text}
        </button>
    );
};
